import { z } from "zod";
import * as directoryScheme from "./directoryScheme";
import * as imageSchema from "./imageSchema";

export const nameHelper =
  "Project name is required. It must have at least 2 characters, max 300 characters, no special characters allowed";
export const nameSchema = directoryScheme.createNameSchema({
  name: "Project Name",
  minLength: 2,
  maxLength: 300,
  allowSpecialChars: false,
  allowNumbers: true,
  required: true,
});

// Code Schema - unique, alphanumeric characters only, special characters allowed: -, _, ., space, min 3 and max 50 characters
export const codeHelper =
  "Code must be 3-50 characters, alphanumeric with allowed special characters: -, _, ., space";
export const codeHelperOptional = `${codeHelper}, optional`;
export const codeSchema = z
  .string()
  .trim()
  .min(3, { message: "Code must be at least 3 characters" })
  .max(50, { message: "Code must not exceed 50 characters" })
  .regex(/^[A-Za-z0-9\s\-_.]+$/, {
    message:
      "Code can only contain alphanumeric characters, spaces, hyphens, underscores, and periods",
  });

// Description Schema - alphanumeric characters only, special characters allowed: -, _, ., space, min 3 and max 1000 characters
export const descriptionHelper =
  "Description must be 3-1000 characters, alphanumeric with allowed special characters: -, _, ., space";
export const descriptionSchema = z
  .string()
  .trim()
  .min(3, { message: "Description must be at least 3 characters" })
  .max(1000, { message: "Description must not exceed 1000 characters" })
  .regex(/^[A-Za-z0-9\s\-_.]+$/, {
    message:
      "Description can only contain alphanumeric characters, spaces, hyphens, underscores, and periods",
  });

export const startDateHelper = "Start Date is required";
export const startDateSchema = z.date().min(new Date(), {
  message: startDateHelper,
});

export const endDateHelper = "End Date is required";
export const endDateSchema = z.date().min(new Date(), {
  message: endDateHelper,
});

export const imageFileHelper = imageSchema.createImageFileHelperText({
  required: false,
});
export const imageFileSchema = imageSchema.createImageFileSchema({
  required: false,
});

export const imageFileArrayHelper =
  imageSchema.createImageFileArrayHelperText();
export const imageFileArraySchema = imageSchema.createImageFileArraySchema();
